import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { blue, placeholderGray } from '@css/constants'

export const GroupLinkWrapper = styled('div')(css`
  padding-top: 24px;
`)

export const GroupTitle = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(20)};
  text-transform: uppercase;
`)

export const LinkText = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  color: ${blue};
  white-space: break-spaces;
  text-align: left;
`)

export const LinkDescription = styled('p')(css`
  ${FontNormal(400)};
  ${fontSize(14)};
  color: ${placeholderGray};
  text-align: initial;

  & > sup {
    ${fontSize(10)};
  }
`)

export const linkStyles = css`
  display: block;
  margin-top: 20px;
  text-decoration: none;

  &:focus::before {
    display: none;
  }
`
